import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "../../api";

interface UserState {
  accessToken: string;
  user: User | null;
}

export const getAuthToken = (): string => {
  return localStorage.getItem("auth_token") ?? "";
};

const initialState: UserState = {
  accessToken: getAuthToken(),
  user: null,
};

export const userSlice = createSlice({
  name: "appUser",
  initialState,
  reducers: {
    setToken: (state, { payload }: PayloadAction<string | null>) => {
      if (payload === null) {
        localStorage.removeItem("auth_token");
      } else {
        localStorage.setItem("auth_token", payload);
      }
      state.accessToken = payload ?? "";
    },
    setUser: (state, { payload }: PayloadAction<User | null>) => {
      state.user = payload;
    },
  },
});
